import { get } from '@ln/core/pwa/ajax';
import ConfigProvider from '../Core/Configuration/ConfigProvider';

const ApiContenidosService = {
    GetRankingSitio(quantity = 3) {
        return new Promise(resolve => {
            get(ConfigProvider.ApiContenidosRankingSitioUrl)
                .then(response => {
                    resolve(JSON.parse(response).items.slice(0, quantity));
                });
        });
    }
};

export default ApiContenidosService;


// WEBPACK FOOTER //
// ./Statics/scripts/Services/ApiContenidosService.js